/* eslint-disable import/no-extraneous-dependencies -- package exports resolve via react-phone-number-input */
import { getCountries } from 'react-phone-number-input';

/** Fallback when company country is not stored (Alphega EU / GB default). */
const DEFAULT_COUNTRY_CODE = 'GB';
const COMPANY_COUNTRY_CODE_KEY = 'companyCountryCode';

const PHONE_COUNTRIES = new Set(getCountries());

export const getCompanyCountryCode = () => {
  const storedCode =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem(COMPANY_COUNTRY_CODE_KEY)
      : null;
  if (storedCode && PHONE_COUNTRIES.has(storedCode)) {
    return storedCode;
  }
  return DEFAULT_COUNTRY_CODE;
};

export { DEFAULT_COUNTRY_CODE };
